import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: h, style: r, ...m }) => {
  const p = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-shangcheng", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-åå"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? i(o, 0, "#262933") : "#262933",
        datafollowfill: c ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.263 11.64H8.244a1.97 1.97 0 0 0-1.955 2.21l.23 1.86a.9.9 0 0 1-1.787.22l-.23-1.861a3.77 3.77 0 0 1 3.742-4.23h1.178a6.64 6.64 0 0 1 13.158 0h1.176a3.77 3.77 0 0 1 3.741 4.23l-1.294 10.522a3.77 3.77 0 0 1-3.741 3.31H9.538a3.77 3.77 0 0 1-3.741-3.31l-.501-4.077a.9.9 0 0 1 1.786-.22l.502 4.077a1.97 1.97 0 0 0 1.954 1.73h12.924a1.97 1.97 0 0 0 1.955-1.73l1.294-10.522a1.97 1.97 0 0 0-1.955-2.21H10.263Zm.982-1.8a4.84 4.84 0 0 1 9.511 0h-9.51Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M10.516 18.786a.9.9 0 0 1 1.265-.14 6.756 6.756 0 0 0 8.44 0 .9.9 0 1 1 1.125 1.405 8.556 8.556 0 0 1-10.69 0 .9.9 0 0 1-.14-1.265Z"
        }
      )
    )
  )));
}, v = x;
export {
  v as default
};
